import { Requester } from './Requester';
import { IManifest, ILoan } from '../types';

export const PatchLoan = async ({
    loanId,
    loan
}: {
    loanId: string;
    loan: IManifest;
}): Promise<{ keyed: Record<string, any> } | null> => {
    try {
        const response = await Requester<{ keyed: Record<string, any> } | null>({
            path: `loans/${loanId}`,
            method: 'PATCH',
            payload: loan
        });

        return response && Object.hasOwn(response, 'keyed') ? (response as { keyed: Record<string, any> }) : null;
    } catch (e) {
        console.error('Patch loan request failed');
        return Promise.reject(e);
    }
};
